export const types = {
  'SET_JOB_TYPES': 'SET_JOB_TYPES',
  'SET_JOB_TYPES_LOADING': 'SET_JOB_TYPES_LOADING',
  'SET_REFRESH_JOB_TYPES_STATUS': 'SET_REFRESH_JOB_TYPES_STATUS'
};
